import { formatDate } from "@/utils/dates";
 
export function matchesMeetingSearch(meet, query) {
  if (!query?.trim()) return true;
  const q = query.trim().toLowerCase();
 
  const haystacks = [
    meet["title"],
    meet["description"],
    meet["location"]?.name,
    meet["meeting_date"],
    meet["meeting_date"] ? formatDate(meet["meeting_date"]) : null,
    ...(meet["members"] ?? []).flatMap((m) => [m.member_fullname, m.member_email]),
  ];
 
  return haystacks.some((val) => val && String(val).toLowerCase().includes(q));
}
 